<template>
  <v-container>
    <v-row>
      <v-col>
        <h2>Club Coaching Summary</h2>
        <task-reporting />
        <v-row>
          <v-col cols="4">
            <v-menu
              ref="menu1"
              v-model="menu1"
              offset-y
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filterDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="For date"
                  prepend-icon="mdi-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filterDate"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <vue-json-to-csv v-if="userTaskSummary" :json-data="userTaskSummary" csv-title="User Task Export">
          <v-btn>
            Download CSV
          </v-btn>
        </vue-json-to-csv>
        <v-data-table
          :headers="taskSummaryHeaders"
          :items="userTaskSummary"
          :items-per-page="100"
          class="mt-2 mb-5 elevation-2 row-pointer"
        >
          <template v-slot:[`item.user`]="props">
            <router-link class="black--text font-weight-bold" :to="`/tasks/${props.item.id}`">
              {{ props.item.user }}
            </router-link>
          </template>
        </v-data-table>
        <vue-json-to-csv v-if="taskReportTypeData" :json-data="taskReportTypeData" csv-title="Task Category Export Time">
          <v-btn>
            Download CSV
          </v-btn>
        </vue-json-to-csv>
        <v-data-table
          :headers="taskReportHeaders"
          :items="taskReportTypeData"
          :items-per-page="100"
          class="mt-2 mb-5 elevation-2 row-pointer"
        >
          <template v-slot:[`item.max_opened`]="props">
            {{ props.item.max_opened | moment("YYYY-MM-DD HH:MM") }}
          </template>
        </v-data-table>
        <vue-json-to-csv v-if="taskSummaryUserData" :json-data="taskSummaryUserData" csv-title="Task Resolution Time">
          <v-btn>
            Download CSV
          </v-btn>
        </vue-json-to-csv>
        <v-data-table
          :headers="taskReportHeaders"
          :items="taskSummaryUserData"
          :items-per-page="100"
          class="mt-2 elevation-2 row-pointer"
        >
          <template v-slot:[`item.max_opened`]="props">
            {{ props.item.max_opened | moment("YYYY-MM-DD HH:MM") }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { STAFF_PROFILE_TASK_QUERY } from "@/graphql/queries/user";
import { TASK_REPORT_QUERY } from "@/graphql/queries/task";
import TaskReporting from "@/components/reporting/blocks/TaskReporting";
import { decodeId } from "@/lib/string";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "ClubSummary",
  components: {
    TaskReporting,
    VueJsonToCsv
  },
  data() {
    return {
      clients: [],
      loading: true,
      filterDate: null,
      userTaskSummary: [],
      taskReportTypeData: [],
      taskSummaryUserData: [],
      menu1: false,
      taskSummaryHeaders: [
        { text: "User", value: "user" },
        { text: "Total active clients", value: "totalClients" },
        { text: "Total messages from clients", value: "messagesFromClients" },
        { text: "% of engaged customers for past 7 days", value: "engagedClients" },
        { text: "Incomplete tasks", value: "incompleteTasks" },
        { text: "Tasks completed for date", value: "tasksCompleted" },
        { text: "Team", value: "team" },
      ],
      taskReportHeaders: [
        { text: "Name", value: "title" },
        { text: "7 day average time to resolve", value: "avg_resolved" },
        { text: "# of tasks unresolved > 7 working hours", value: "not_resolved_7_hours" },
        { text: "Avg age of unresolved", value: "avg_open" },
        { text: "Oldest unresolved", value: "max_opened" },
      ],
    };
  },
  apollo: {
    taskEventReport: {
      query: TASK_REPORT_QUERY,
      result(response) {
        if (response.data) {
          var reportData = JSON.parse(response.data.taskEventReport.report.data);
          this.taskReportTypeData = [];
          this.taskSummaryUserData = [];

          for (var k in reportData["task"]) {
            this.taskReportTypeData.push({
              title: k,
              ...reportData["task"][k],
            });
          }
          for (var k in reportData["user"]) {
            this.taskSummaryUserData.push({
              title: k,
              ...reportData["user"][k],
            });
          }
        }
      },
    },
    clients: {
      query: STAFF_PROFILE_TASK_QUERY,
      variables() {
        if (!this.filterDate) {
          return {};
        }

        return {
          filterDate: this.filterDate,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          var summaryData = {};
          this.userTaskSummary = response.data.clients.edges.map((item) => {
            if (!(item.node.team.name in summaryData)) {
              summaryData[item.node.team.name] = {
                user: item.node.team.name,
                team: item.node.team.name,
                totalClients: 0,
                incompleteTasks: 0,
                tasksCompleted: 0,
                messagesFromClients: 0,
                engagedClients: 0,
              };
            }

            summaryData[item.node.team.name]["totalClients"] += item.node.totalClients;
            summaryData[item.node.team.name]["incompleteTasks"] += item.node.assignedToIncompleteTasks;
            summaryData[item.node.team.name]["tasksCompleted"] += item.node.tasksCompleted;
            summaryData[item.node.team.name]["messagesFromClients"] += item.node.messagesFromClients;

            return {
              id: decodeId(item.node.user.id),
              user: `${item.node.user.firstName} ${item.node.user.lastName}`,
              totalClients: item.node.totalClients,
              incompleteTasks: item.node.assignedToIncompleteTasks,
              tasksCompleted: item.node.tasksCompleted,
              messagesFromClients: item.node.messagesFromClients,
              team: item.node.team.name,
              engagedClients:
                item.node.totalClients > 0
                  ? parseFloat((item.node.engagedClients / item.node.totalClients) * 100).toFixed(0)
                  : 0,
            };
          });
          for (var key in summaryData) {
            summaryData[key]["engagedClients"] =
              summaryData[key]["totalClients"] > 0
                ? parseFloat((summaryData[key]["engagedClients"] / summaryData[key]["totalClients"]) * 100).toFixed(0)
                : 0;
            this.userTaskSummary.push(summaryData[key]);
          }
        }
      },
    },
  },
};
</script>
